//  eslint-disable react-hooks/exhaustive-deps
import React, { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  filterBy,
  CompositeFilterDescriptor,
} from "@progress/kendo-data-query";
import {
  Grid as KendoGrid,
  GridColumn as Column,
  //   GridCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  GridCustomHeaderCellProps,
  GridCustomCellProps,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { Typography } from "@progress/kendo-react-common";

import { LoadingPanel } from "../../components/layout/Loading";

import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";

import AppDrawer from "../../components/drawer/Drawer";

import { getAllPortDataimport } from "./services/portDataimport";
import PortDataimport from "./UploadPortDataimport";
import { Button } from "@progress/kendo-react-buttons";
import { useNavigate } from "react-router-dom";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";
import { filterIcon } from "@progress/kendo-svg-icons";

import { clearFilter } from "./portdataimportSlice";
import PortFilter from "./PortFilter";
import { RootState } from "../../app/store";
import { Badge } from "@progress/kendo-react-indicators";
import moment from "moment";

import {
  // DELETE_ACCESS,
  // EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import { checkAcessRights } from "../../_helper/helper";

const PortDataimportTable: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);

  const isFilterSet = useAppSelector(
    (state: RootState) => state.portdata.isFilterSet
  );

  useEffect(() => {
    return () => {
      dispatch(closeDialog());
      dispatch(clearFilter());
    };
  }, []);
  const handleAccountCreate = () => {
    navigate("/portimportdata/uplod");
  };
  const handleOpenPortFilter = () => {
    dispatch(openDialog("PortFilter"));
  };

  return (
    <>
      <PortFilter />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Port Data Import
          </Typography.h4>
          {/* <Button label="Upload PortDataFile" drawerName="portdataForm" onClick={handleAccountCreate} /> */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginLeft: "auto",
              paddingRight: "20px",
              gap: "15px",
            }}
          >
            <Button
              onClick={handleOpenPortFilter}
              fillMode={"solid"}
              themeColor={"primary"}
              svgIcon={filterIcon}
              // style={{ marginRight: 9 }}
            >
              Filter
              {isFilterSet ? <Badge themeColor="error" /> : ""}
            </Button>
            {isAddAccess && (
              <Button
                onClick={handleAccountCreate}
                fillMode={"solid"}
                themeColor={"primary"}
              >
                Uplod New Data
              </Button>
            )}
          </div>
        </GridLayoutItem>
        <GridLayoutItem>
          <PortDataImportGridComponent />
        </GridLayoutItem>
        {isDrawerOpen && drawerName === "portdataForm" && (
          <AppDrawer>
            <PortDataimport />
          </AppDrawer>
        )}
      </GridLayout>
    </>
  );
};

const PortDataImportGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const PortDataimportList = useAppSelector(
    (state) => state.portdata.PortDataimportList
  );
  const loading = useAppSelector((state) => state.portdata.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const cellfilter = useAppSelector((state) => state.portdata.filter);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  useEffect(() => {
    const payload = {
      ...cellfilter,
      sb_date: cellfilter?.sb_date
        ? moment(cellfilter?.sb_date).format("YYYY-MM-DD")
        : "",
      leo_date: cellfilter?.leo_date
        ? moment(cellfilter?.leo_date).format("YYYY-MM-DD")
        : "",
      limit: +pageLimit,
      skip: +currentPage * +pageLimit,
    };
    dispatch(getAllPortDataimport(payload));
  }, [currentPage, pageLimit]);

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };
  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}

      <KendoGrid
        className="sipping-moment-list-grid"
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        onFilterChange={handleFilterChange}
        data={
          filter ? filterBy(PortDataimportList, filter) : PortDataimportList
        }
        total={PortDataimportList[0]?.item_count || PortDataimportList.length}
        skip={currentPage * pageLimit}
        take={pageLimit}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 50, 100, 300, 500],
          pageSizeValue: pageLimit,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column field="sb_no" title="SB No" />
        <Column field="sb_date" title="SB Date" />
        <Column field="leo_date" title="Leo Date" />
        <Column field="lec" title="Lec" />
        <Column field="exporter_name" title="Exporter Name" />
        <Column field="consignee_name" title="Consignee Name" />
        <Column
          field="country_of_destination"
          title="Country  Of Destination"
        />
        <Column field="port_of_discharge" title="Port Of Discharge" />
      </KendoGrid>
    </>
  );
};

// const CommonFilterCell = (props: any) => {
//   const dispatch = useAppDispatch();
//   const currentPage = useAppSelector((state) => state.pagination.currentPage);
//   const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
//   const FilterCustomPIT: any = useAppSelector(
//     (state) => state.portdata.FilterCustomPIT
//   );
//   const isFilterRef = useRef(true);
//   const [inputValue, setInputValue] = useState(props.value || "");
//   const [inputField, setInputField] = useState(props.field || "");

//   const onChange = (event: any) => {
//     setInputValue(event.target.value);
//     setInputField(event.target.name);
//   };

//   const delayedApiCall = React.useCallback(
//     _debounce((updatedFilters: any) => {
//       dispatch(setCurrentPage(0));
//       const payload = {
//         ...updatedFilters,
//         limit: +pageLimit,
//         skip: 0 * +pageLimit,
//       };

//       dispatch(getAllPortDataimport(payload));
//     }, 300),
//     [dispatch]
//   );

//   useEffect(() => {
//     if (!isFilterRef.current) {
//       const updatedFilters = { ...FilterCustomPIT, [inputField]: inputValue };
//       dispatch(setFilterCustomPIT(updatedFilters));
//       delayedApiCall(updatedFilters);
//     } else {
//       isFilterRef.current = false;
//     }
//     return () => {
//       delayedApiCall.cancel();
//     };
//   }, [inputValue, delayedApiCall]);

//   const onClearButtonClick = (event: any) => {
//     event.preventDefault();
//     props.onChange({
//       value: null,
//       operator: "",
//       syntheticEvent: event,
//     });

//     const updatedFilters = { ...FilterCustomPIT, [props.field]: "" };
//     dispatch(setFilterCustomPIT(updatedFilters));

//     const payload = {
//       ...updatedFilters,
//       limit: +pageLimit,
//       skip: +currentPage * +pageLimit,
//     };

//     dispatch(getAllPortDataimport(payload));
//   };
//   return (
//     <div className="d-flex">
//       <TextBox
//         value={FilterCustomPIT[props.field] || ""}
//         name={props.field || ""}
//         onChange={onChange}
//       />
//       <Button
//         svgIcon={filterClearIcon}
//         title="Clear"
//         disabled={!FilterCustomPIT[props.field]}
//         onClick={onClearButtonClick}
//         type="button"
//         style={{
//           marginLeft: "8px",
//         }}
//       ></Button>
//     </div>
//   );
// };

export default PortDataimportTable;
